import lureoSquiggle1 from '@/assets/Lureo_Squiggle-01-quarter-size.png';
import lureoSquiggle2 from '@/assets/Lureo_Squiggle-02-quarter-size.png';

const ASSET_RATIO = { 1: 889 / 2083, 2: 789 / 2246 };
const ASSETS = { 1: lureoSquiggle1, 2: lureoSquiggle2 };

interface Placement {
  squiggle: 1 | 2;
  widthPct: number;
  anchorX: 'left' | 'right';
  anchorY: 'top' | 'bottom';
  dx: number;
  dy: number;
  rotate: number;
}

const WIDE_PLACEMENTS: Placement[] = [
  { squiggle: 1, widthPct: 255, anchorX: 'left', anchorY: 'bottom', dx: -15, dy: -15, rotate: 60 },
  { squiggle: 2, widthPct: 255, anchorX: 'left', anchorY: 'bottom', dx: -210, dy: -15, rotate: 30 },
  { squiggle: 1, widthPct: 255, anchorX: 'left', anchorY: 'bottom', dx: -15, dy: 5, rotate: 255 },
  { squiggle: 2, widthPct: 255, anchorX: 'left', anchorY: 'bottom', dx: -165, dy: 5, rotate: 75 },
  { squiggle: 1, widthPct: 255, anchorX: 'left', anchorY: 'bottom', dx: 5, dy: -15, rotate: 270 },
  { squiggle: 1, widthPct: 255, anchorX: 'left', anchorY: 'top', dx: -125, dy: 5, rotate: 60 },
  { squiggle: 2, widthPct: 255, anchorX: 'left', anchorY: 'top', dx: -15, dy: -15, rotate: 45 },
  { squiggle: 1, widthPct: 255, anchorX: 'left', anchorY: 'top', dx: -210, dy: 5, rotate: 150 },
  { squiggle: 2, widthPct: 255, anchorX: 'left', anchorY: 'top', dx: 5, dy: -90, rotate: 105 },
  { squiggle: 1, widthPct: 255, anchorX: 'left', anchorY: 'top', dx: -15, dy: 5, rotate: 225 },
  { squiggle: 1, widthPct: 255, anchorX: 'right', anchorY: 'bottom', dx: -15, dy: -15, rotate: 45 },
  { squiggle: 2, widthPct: 255, anchorX: 'right', anchorY: 'bottom', dx: 5, dy: 5, rotate: 75 },
  { squiggle: 1, widthPct: 255, anchorX: 'right', anchorY: 'bottom', dx: 5, dy: -165, rotate: 90 },
  { squiggle: 2, widthPct: 255, anchorX: 'right', anchorY: 'bottom', dx: -35, dy: -125, rotate: 90 },
  { squiggle: 1, widthPct: 255, anchorX: 'right', anchorY: 'bottom', dx: -210, dy: -15, rotate: 150 },
  { squiggle: 1, widthPct: 255, anchorX: 'right', anchorY: 'top', dx: -15, dy: -15, rotate: 75 },
  { squiggle: 2, widthPct: 255, anchorX: 'right', anchorY: 'top', dx: -35, dy: 5, rotate: 90 },
  { squiggle: 1, widthPct: 255, anchorX: 'right', anchorY: 'top', dx: 5, dy: 5, rotate: 90 },
  { squiggle: 2, widthPct: 255, anchorX: 'right', anchorY: 'top', dx: 5, dy: 5, rotate: 135 },
  { squiggle: 1, widthPct: 255, anchorX: 'right', anchorY: 'top', dx: -15, dy: -15, rotate: 240 },
];

const TALL_PLACEMENTS: Placement[] = [
  { squiggle: 1, widthPct: 255, anchorX: 'left', anchorY: 'bottom', dx: -15, dy: 5, rotate: 255 },
  { squiggle: 2, widthPct: 255, anchorX: 'left', anchorY: 'bottom', dx: -210, dy: -15, rotate: 30 },
  { squiggle: 1, widthPct: 255, anchorX: 'left', anchorY: 'bottom', dx: 5, dy: 5, rotate: 270 },
  { squiggle: 2, widthPct: 255, anchorX: 'left', anchorY: 'bottom', dx: -165, dy: 5, rotate: 75 },
  { squiggle: 1, widthPct: 300, anchorX: 'left', anchorY: 'bottom', dx: -165, dy: -15, rotate: 45 },
  { squiggle: 1, widthPct: 255, anchorX: 'left', anchorY: 'top', dx: -125, dy: -35, rotate: 75 },
  { squiggle: 2, widthPct: 255, anchorX: 'left', anchorY: 'top', dx: -15, dy: -15, rotate: 45 },
  { squiggle: 1, widthPct: 255, anchorX: 'left', anchorY: 'top', dx: -15, dy: 5, rotate: 225 },
  { squiggle: 2, widthPct: 255, anchorX: 'left', anchorY: 'top', dx: 5, dy: -60, rotate: 105 },
  { squiggle: 1, widthPct: 255, anchorX: 'left', anchorY: 'top', dx: 5, dy: -90, rotate: 270 },
  { squiggle: 1, widthPct: 255, anchorX: 'right', anchorY: 'bottom', dx: -15, dy: -15, rotate: 45 },
  { squiggle: 2, widthPct: 255, anchorX: 'right', anchorY: 'bottom', dx: 5, dy: 5, rotate: 75 },
  { squiggle: 1, widthPct: 255, anchorX: 'right', anchorY: 'bottom', dx: 5, dy: -90, rotate: 90 },
  { squiggle: 2, widthPct: 255, anchorX: 'right', anchorY: 'bottom', dx: -35, dy: -60, rotate: 90 },
  { squiggle: 1, widthPct: 255, anchorX: 'right', anchorY: 'bottom', dx: -125, dy: -35, rotate: 255 },
  { squiggle: 1, widthPct: 255, anchorX: 'right', anchorY: 'top', dx: -15, dy: 5, rotate: 75 },
  { squiggle: 2, widthPct: 255, anchorX: 'right', anchorY: 'top', dx: -15, dy: 5, rotate: 120 },
  { squiggle: 1, widthPct: 255, anchorX: 'right', anchorY: 'top', dx: 5, dy: 5, rotate: 90 },
  { squiggle: 2, widthPct: 255, anchorX: 'right', anchorY: 'top', dx: 5, dy: 5, rotate: 135 },
  { squiggle: 1, widthPct: 300, anchorX: 'right', anchorY: 'top', dx: -35, dy: -15, rotate: 75 },
];

const hashOf = (id: string) => {
  let h = 2166136261;
  for (let i = 0; i < id.length; i++) {
    h ^= id.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  h ^= h >>> 13;
  h = Math.imul(h, 2246822507);
  h ^= h >>> 16;
  return h >>> 0;
};

interface SquiggleCornerProps {
  id: string;
  shape: 'wide' | 'tall';
}

export function SquiggleCorner({ id, shape }: SquiggleCornerProps) {
  const placements = shape === 'wide' ? WIDE_PLACEMENTS : TALL_PLACEMENTS;
  const p = placements[hashOf(id) % placements.length];
  const aspect = 1 / ASSET_RATIO[p.squiggle];

  return (
    <div
      aria-hidden
      className="pointer-events-none absolute"
      style={{
        [p.anchorX]: `${p.dx}%`,
        [p.anchorY]: `${p.dy}%`,
        width: `${p.widthPct}%`,
        aspectRatio: `${aspect}`,
        backgroundImage: `url(${ASSETS[p.squiggle]})`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        transform: `rotate(${p.rotate}deg)`
      }}
    />
  );
}
